import { ArrowRight, Sparkle } from 'lucide-react';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { DISCOVER_AN_EVENT_ACTION, FIRST_EVENT_HEADING, FIRST_EVENT_LINE } from './constants';

/**
 * **Find your first event** — `MEM-052` AC-8, Brad's simplified banner (comment on TW 44189308,
 * 2026-09-26; built on TW 44213018, Sumit 2026-09-27, *"proceed with option A"*).
 *
 * Drawn in the Next up card's place while a signed-in member has no upcoming place. The spark
 * gradient (`bg-spark`, fuchsia to purple, the one the match cards use) at `--radius-2xl` with
 * `--shadow-md`, as the Next up card is; a sparkle beside the heading, white, at `var(--text-2xl)`, one
 * sentence under it, and a white pill at the right, *Discover an event* with an arrow, opening
 * Discover. On the phone the button wraps beneath the sentence.
 *
 * The earlier design's bell and its promise of when a member hears about matches are not built
 * (option A).
 */
export function FirstEventCard(): React.ReactElement {
  return (
    <section
      aria-labelledby="first-event-heading"
      className="flex flex-wrap items-center justify-between gap-5 rounded-2xl bg-spark px-6 py-6 text-white shadow-md md:px-[26px]"
    >
      <div className="min-w-0 flex-1 basis-72">
        <h2
          id="first-event-heading"
          className="flex items-center gap-2 font-brand text-2xl font-bold tracking-tight text-white"
        >
          <Sparkle aria-hidden className="h-6 w-6 flex-none fill-current" strokeWidth={1.5} />
          {FIRST_EVENT_HEADING}
        </h2>
        <p className="mt-1.5 text-md text-white/90">{FIRST_EVENT_LINE}</p>
      </div>
      <Link
        to="/app"
        className="inline-flex flex-none items-center gap-2.5 rounded-pill bg-white px-6 py-3 font-brand text-md font-bold text-primary transition-colors hover:bg-brand-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-primary"
      >
        {DISCOVER_AN_EVENT_ACTION}
        <ArrowRight aria-hidden className="h-4 w-4" />
      </Link>
    </section>
  );
}
